import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useMemberNotes(clubId: string | null, memberId: string) {
	return useQuery({
		queryKey: queryKeys.clubPortal.memberNotes(clubId ?? "", memberId),
		queryFn: () => clubApi.notes.list(clubId!, memberId),
		enabled: !!clubId && !!memberId,
	});
}

export function useCreateMemberNote(clubId: string, memberId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (content: string) => clubApi.notes.create(clubId, memberId, content),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "members", memberId, "notes"],
			}),
	});
}

export function useDeleteMemberNote(clubId: string, memberId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (noteId: string) => clubApi.notes.delete(clubId, memberId, noteId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: ["club-portal", "clubs", clubId, "members", memberId, "notes"],
			}),
	});
}
